import axios from "./axios";

class ResultRepository {
  get(name, sportsId) {
    return axios
      .get(`/results`, {
        params: {
          name: name,
          sports_id: sportsId,
        },
      })
      .then((response) => {
        return response.data;
      });
  }
}

export default new ResultRepository();



// WEBPACK FOOTER //
// ./src/data/result.repository.js